
import React from 'react';
import { PenTool, CheckCircle2 } from 'lucide-react';
import { Language } from '../types';

interface SaveIndicatorProps {
  active: boolean;
  language: Language;
}

const SaveIndicator: React.FC<SaveIndicatorProps> = ({ active, language }) => {
  const t = {
    pt: { saving: 'Selando Alterações...', saved: 'Acervo Sincronizado' },
    en: { saving: 'Sealing Changes...', saved: 'Collection Synced' },
    es: { saving: 'Guardando Cambios...', saved: 'Colección Sincronizada' },
    ru: { saving: 'Сохранение...', saved: 'Коллекция Синхронизирована' }
  }[language] || { saving: 'Sealing Changes...', saved: 'Collection Synced' };

  return (
    <div className={`fixed bottom-8 left-8 z-[1200] flex items-center gap-4 transition-all duration-500 pointer-events-none ${active ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
      <div className="bg-zinc-950/95 backdrop-blur-2xl border border-purple-500/30 px-6 py-3.5 flex items-center gap-3 shadow-[0_0_30px_rgba(0,0,0,0.8)]">
        <div className={`p-2 bg-white ${active ? 'animate-pulse' : ''}`}>
           {active ? <PenTool className="w-4 h-4 text-[#c084fc]" /> : <CheckCircle2 className="w-4 h-4 text-green-500" />}
        </div>
        <div className="flex flex-col">
          <span className="text-[9px] font-black text-white uppercase tracking-[0.3em]">{active ? t.saving : t.saved}</span>
          <div className="h-0.5 bg-[#c084fc]/20 w-full mt-1 overflow-hidden">
             <div className={`h-full bg-[#c084fc] transition-all duration-1000 ${active ? 'w-full' : 'w-0'}`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveIndicator;
